import React from 'react';
import { Form, Alert } from 'react-bootstrap';
import { FaInfoCircle, FaPlus, FaRedo } from 'react-icons/fa';
import './ModifierConfigurationSection.scss';

interface ModifierConfiguration {
  is_optional: boolean;
  is_price_setter: boolean;
}

interface ModifierConfigurationSectionProps {
  modifierConfiguration: ModifierConfiguration;
  setModifierConfiguration: React.Dispatch<React.SetStateAction<ModifierConfiguration>>;
  selectedModifierName: string;
  currentItemName?: string;
}

const ModifierConfigurationSection: React.FC<ModifierConfigurationSectionProps> = ({
  modifierConfiguration,
  setModifierConfiguration,
  selectedModifierName,
  currentItemName = 'este producto'
}) => {
  const generateExplanationMessage = () => {
    const mandatoryText = !modifierConfiguration.is_optional ? 'deberá elegir' : 'podrá elegir opcionalmente';
    const priceText = modifierConfiguration.is_price_setter ? 
      'reemplazará el precio base del producto' : 
      'se agregará al precio base del producto';
    
    return `Cuando tu cliente compre un ${currentItemName}, ${mandatoryText} una opción de "${selectedModifierName}". El precio de la opción seleccionada ${priceText}.`;
  };

  return (
    <div className="modifier-configuration-section">
      <div className="configuration-form">
        {/* Price Type Selector */}
        <div className="form-group">
          <Form.Label>Tipo de Precio *</Form.Label>
          <div className="price-type-selector">
            <div 
              className={`price-option ${!modifierConfiguration.is_price_setter ? 'active' : ''}`}
              onClick={() => setModifierConfiguration(prev => ({ ...prev, is_price_setter: false }))}
            >
              <div className="option-icon">
                <FaPlus />
              </div>
              <div className="option-content">
                <h6>Agregar al Precio</h6>
                <p>El precio de la opción se suma al precio base del producto</p>
                <div className="example">Ej: Producto $10 + Opción $3 = $13</div>
              </div>
            </div>
            
            <div 
              className={`price-option ${modifierConfiguration.is_price_setter ? 'active' : ''}`}
              onClick={() => setModifierConfiguration(prev => ({ ...prev, is_price_setter: true }))}
            >
              <div className="option-icon">
                <FaRedo />
              </div>
              <div className="option-content">
                <h6>Reemplazar Precio</h6>
                <p>El precio de la opción reemplaza completamente el precio base</p>
                <div className="example">Ej: Producto $10 → Opción $15 = $15</div>
              </div>
            </div>
          </div>
        </div>

        {/* Mandatory Selector */}
        <div className="form-group">
          <Form.Label>Tipo de Selección *</Form.Label>
          <div className="mandatory-selector">
            <div 
              className={`mandatory-option ${modifierConfiguration.is_optional ? 'active' : ''}`}
              onClick={() => setModifierConfiguration(prev => ({ ...prev, is_optional: true }))}
            >
              <div className="option-content">
                <h6>Opcional</h6>
                <p>El cliente puede seleccionar una opción o dejarla en blanco</p>
              </div>
            </div>
            
            <div 
              className={`mandatory-option ${!modifierConfiguration.is_optional ? 'active' : ''}`}
              onClick={() => setModifierConfiguration(prev => ({ ...prev, is_optional: false }))}
            >
              <div className="option-content">
                <h6>Obligatorio</h6>
                <p>El cliente debe seleccionar una opción antes de continuar</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dynamic Explanation */}
      <Alert variant="info" className="explanation-alert">
        <div className="explanation-content">
          <FaInfoCircle className="explanation-icon" />
          <div className="explanation-text">
            <h6>¿Cómo funcionará este modificador?</h6>
            <p>{generateExplanationMessage()}</p>
          </div>
        </div>
      </Alert>
    </div>
  );
};

export default ModifierConfigurationSection;
